import { mdiFolderOutline } from '@mdi/js'
import { JobInfo } from 'features/jobs/components'

// TODO: Localization
export const JOB_INFO_ROUTES = [
  {
    component: JobInfo,
    icon: mdiFolderOutline,
    path: 'info',
    title: 'Job Info',
  },
]
